import { useState, useCallback } from 'react';
import { initialState, LinkPlugin } from './LinkPlugin';
import { setLinkMark, setLinkText } from './LinkUtils';
import { chainCommands } from 'prosemirror-commands';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { Tracker } from '../../../utils/usageTracker';
import { UPDATE_LINK } from 'rich-text-lib/constants/usageTracking';
import { PM_LINK } from '../../constants/events';
import { encodeUrl, ensureUrlHasProtocol } from '../../../draft-transplant/utils/libUtils';
import LinkForm from '../../../draft-transplant/components/LinkForm';
import { jsx as _jsx } from "react/jsx-runtime";
export default function LinkContent(props) {
  const {
    markBounds,
    editorView,
    initialText,
    initialHref,
    initialTarget,
    target,
    paymentLinkReferrer
  } = props;
  const [text, setText] = useState(initialText || '');
  const [href, setHref] = useState(initialHref || '');
  const [isTargetBlank, setTargetBlank] = useState(initialTarget);
  const onSave = useCallback(() => {
    const urlWithProtocol = ensureUrlHasProtocol(href);
    const encodedUrl = encodeUrl(urlWithProtocol);
    chainCommands(setLinkText(text, markBounds.from, markBounds.to), setLinkMark({
      href: encodedUrl,
      isTargetBlank
    }, markBounds.from, markBounds.to))(editorView.state, editorView.dispatch);
    Tracker.track(PM_LINK, {
      action: UPDATE_LINK,
      externalLink: isTargetBlank,
      isImage: false,
      noFollow: false,
      isPaymentLink: encodedUrl && encodedUrl.includes(`referrer=${paymentLinkReferrer}`)
    });
  }, [text, markBounds, editorView, href, isTargetBlank, paymentLinkReferrer]);
  const onLinkChange = useCallback(params => {
    if (params.url !== undefined) setHref(params.url);
    if (params.text !== undefined) setText(params.text);
    if (params.isTargetBlank !== undefined) setTargetBlank(params.isTargetBlank);
  }, [setText, setHref, setTargetBlank]);
  const onLinkRemove = useCallback(() => {
    let tr = editorView.state.tr;
    const {
      schema
    } = editorView.state;
    tr = tr.removeMark(markBounds.from, markBounds.to, schema.marks.link);
    editorView.dispatch(tr);
  }, [markBounds, editorView]);
  const onCancel = useCallback(() => {
    let tr = editorView.state.tr;
    tr = tr.setMeta(LinkPlugin, initialState);
    editorView.dispatch(tr);
  }, [editorView]);
  return /*#__PURE__*/_jsx(UIPopover, {
    open: true,
    content: /*#__PURE__*/_jsx(LinkForm, {
      isNew: false,
      text: text,
      url: href,
      isTargetBlank: isTargetBlank,
      isNoFollow: true,
      onChange: onLinkChange,
      onConfirm: onSave,
      onCancel: onCancel,
      onRemove: onLinkRemove,
      hideNoFollowConfiguration: true
    }),
    target: target
  });
}